// extracted by mini-css-extract-plugin
module.exports = {"passModal":"src-AdminPanel-pages-Users-UpdatePassword-styles-style-module__passModal--385Eo"};